/**
 * Common Kanji Unicode to Shift-JIS mapping
 * This covers the most frequently used kanji characters (JIS Level 1)
 * Format: Unicode code point -> Shift-JIS two-byte value
 *
 * Note: Duplicates have been removed. Each kanji appears only once.
 */
export const KANJI_MAP: Record<number, number> = {
  // Numbers
  19968: 0x88ea, // 一
  20108: 0x93f1, // 二
  19977: 0x8e4f, // 三
  22235: 0x8e6c, // 四
  20116: 0x8cdc, // 五
  20845: 0x985a, // 六
  19971: 0x8eb5, // 七
  20843: 0x94aa, // 八
  20061: 0x8be3, // 九
  21313: 0x8f5c, // 十
  30334: 0x9553, // 百
  21315: 0x90e7, // 千
  19975: 0x969c, // 万
  20740: 0x89ad, // 億

  // Time/Calendar
  26085: 0x93fa, // 日
  26376: 0x8c8e, // 月
  28779: 0x89ce, // 火
  27700: 0x9085, // 水
  26408: 0x96d8, // 木
  37329: 0x8be0, // 金
  22303: 0x9379, // 土
  24180: 0x944e, // 年
  26178: 0x8e9e, // 時
  20998: 0x95aa, // 分
  31186: 0x9562, // 秒
  20170: 0x8da1, // 今
  26152: 0x8dfa, // 昨
  26126: 0x96be, // 明

  // People/Body
  20154: 0x906c, // 人
  30007: 0x926a, // 男
  22899: 0x8f97, // 女
  23376: 0x8e71, // 子
  27597: 0x95ea, // 母
  29238: 0x9583, // 父
  21451: 0x9746, // 友
  25163: 0x8ee8, // 手
  36275: 0x91ab, // 足
  30446: 0x96da, // 目
  32819: 0x8ea8, // 耳
  21475: 0x8cfb, // 口
  40763: 0x9540, // 鼻
  24515: 0x9053, // 心

  // Nature
  23665: 0x8e52, // 山
  24029: 0x90ec, // 川
  28023: 0x8a43, // 海
  31354: 0x8bf3, // 空
  38632: 0x8941, // 雨
  39080: 0x9597, // 風
  38634: 0x90e1, // 雪
  33457: 0x89d4, // 花
  33609: 0x9190, // 草
  27193: 0x8ef7, // 樹
  26519: 0x97d1, // 林
  26862: 0x9058, // 森

  // Actions
  35211: 0x8ca9, // 見
  32862: 0x95b7, // 聞
  35328: 0x8cbe, // 言
  35501: 0x93c7, // 読
  26360: 0x8f91, // 書
  35441: 0x9862, // 話
  39135: 0x9048, // 食
  39154: 0x88f9, // 飲
  36208: 0x9196, // 走
  27497: 0x95e0, // 歩
  31435: 0x97a7, // 立
  24231: 0x8dc0, // 座
  23517: 0x9051, // 寝
  36215: 0x8b4e, // 起
  20316: 0x8dec, // 作
  20351: 0x8e67, // 使
  25345: 0x8e9d, // 持
  21462: 0x8ee6, // 取
  20986: 0x8f6f, // 出
  20837: 0x93fc, // 入
  34892: 0x8d73, // 行
  26469: 0x9788, // 来
  24112: 0x8b41, // 帰
  24453: 0x91d2, // 待
  20250: 0x89ef, // 会
  30693: 0x926d, // 知
  24605: 0x8e76, // 思
  32771: 0x8d6c, // 考
  20449: 0x904d, // 信
  24859: 0x88a4, // 愛

  // Places/Buildings
  23478: 0x89c6, // 家
  24215: 0x9358, // 店
  39365: 0x8977, // 駅
  23398: 0x8a77, // 学
  26657: 0x8d5a, // 校
  31038: 0x8ed0, // 社
  22269: 0x8d91, // 国
  24066: 0x8e73, // 市
  30010: 0x92ac, // 町
  26449: 0x91ba, // 村
  36947: 0x93b9, // 道
  27211: 0x8bb4, // 橋

  // Objects
  36554: 0x8e4d, // 車
  38651: 0x9364, // 電
  26412: 0x967b, // 本
  26032: 0x9056, // 新
  32025: 0x8e86, // 紙
  31558: 0x954d, // 筆
  37549: 0x929e, // 銭
  37347: 0x91e3, // 釣

  // Adjectives
  22823: 0x91e5, // 大
  23567: 0x8f8f, // 小
  39640: 0x8d82, // 高
  20302: 0x92e1, // 低
  38263: 0x92b7, // 長
  30701: 0x925a, // 短
  33391: 0x97c7, // 良
  24746: 0x88ab, // 悪
  21476: 0x8cc3, // 古
  22810: 0x91bd, // 多
  23569: 0x8fad, // 少
  24375: 0x8bad, // 強
  24369: 0x8ee3, // 弱
  26263: 0x88c3, // 暗
  28201: 0x89b7, // 温
  23506: 0x8aa6, // 寒
  29105: 0x944d, // 熱
  20919: 0x97e2, // 冷

  // Colors
  36196: 0x90d4, // 赤
  38738: 0x90c2, // 青
  30333: 0x9492, // 白
  40658: 0x8d95, // 黒
  32209: 0x97ce, // 緑
  40644: 0x89a9, // 黄

  // Position/Direction
  20013: 0x9286, // 中
  22806: 0x8a4f, // 外
  19978: 0x8fe3, // 上
  19979: 0x89ba, // 下
  24038: 0x8db6, // 左
  21491: 0x8945, // 右
  21069: 0x914f, // 前
  24460: 0x8ce3, // 後
  21271: 0x967b, // 北
  21335: 0x93ec, // 南
  26481: 0x938c, // 東
  35199: 0x90bc, // 西
  20869: 0x93e0, // 内

  // Common abstract concepts
  29289: 0x95a8, // 物
  20107: 0x8e96, // 事
  32773: 0x8ed2, // 者
  25152: 0x8f8a, // 所
  26041: 0x95fb, // 方
  27671: 0x8b43, // 気
  21147: 0x97cd, // 力
  21517: 0x96bc, // 名
  27425: 0x8e9f, // 次
  21021: 0x8f89, // 初
  26368: 0x8dc5, // 最
  26411: 0x9696, // 末
  20808: 0x90e6, // 先
  27096: 0x9798, // 様
  24335: 0x8eae, // 式
  24615: 0x90ab, // 性
  21270: 0x89bb, // 化
  29992: 0x9770, // 用
  24471: 0x93be, // 得
  22833: 0x8eb8, // 失
  21487: 0x89c2, // 可
  19981: 0x9573, // 不
  28961: 0x96b3, // 無
  26377: 0x974c, // 有
  20840: 0x9153, // 全
  37096: 0x9594, // 部
  21322: 0x94bc, // 半
  27491: 0x90b3, // 正
  35492: 0x8ce0, // 誤
  30495: 0x905e, // 真
  20605: 0x8b55, // 偽
  22987: 0x8e6e, // 始
  32066: 0x8f49, // 終
  32154: 0x91b1, // 続
  27490: 0x8e7e, // 止
  21205: 0x93ae, // 動
  38745: 0x90c3, // 静
  22793: 0x95cf, // 変
  21516: 0x93af, // 同
  21029: 0x95ca, // 別
  29305: 0x93c1, // 特
  26222: 0x9581, // 普
  36890: 0x92ca, // 通
  20849: 0x8ba4, // 共
  31169: 0x8e84, // 私
  20844: 0x8cf6, // 公
  20491: 0x8cc2, // 個
  22243: 0x9263, // 団
  20307: 0x91cc, // 体
  32676: 0x8c51, // 群
  38598: 0x8f57, // 集
  21512: 0x8d87, // 合
  35299: 0x89f0, // 解
  32080: 0x8c8b, // 結
  38283: 0x8a4a, // 開
  38281: 0x95c2, // 閉
  29983: 0x90b6, // 生
  27515: 0x8e80, // 死
  20581: 0x8c92, // 健
  24247: 0x8d4e, // 康
  30149: 0x9561, // 病
  21307: 0x88e3, // 医
  34220: 0x96f2, // 薬

  // Question words
  20309: 0x89bd, // 何
  35504: 0x924e, // 誰
};
